import { styled } from '@mui/material';
import { useViewport } from 'contexts/viewport';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'shell/components/Box';
import CompletionButton from 'shell/components/CompletionButton';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const Step = memo(({ steps, index }) => {
    const { device } = useViewport();
    const { t } = useTranslation();

    const currentStep = steps[index];
    const isCurrentStepLast = index === steps.length - 1;

    return (
        <Stack
            sx={currentStep.disabled ? { opacity: 0.4 } : {}}
            key={index}
            direction={'row'}
            spacing={device === 'mobile' ? 2 : 4}
        >
            <Stack alignItems={'center'} spacing={3}>
                <CompletionButton checked={currentStep.completed} />
                {!isCurrentStepLast ? (
                    <GreyLine completed={currentStep.completed} disabled={currentStep.disabled} />
                ) : null}
            </Stack>
            <Stack sx={{ flex: 1, minWidth: 0 }} spacing={1}>
                <Text color={'light'} variant={'p3'} sx={{ textTransform: 'uppercase' }}>
                    {t('ui.step', 'STEP')} {index + 1}
                </Text>
                {currentStep.element}
            </Stack>
        </Stack>
    );
});

const Steps = memo(({ steps }) => {
    return (
        <Stack spacing={3}>
            {steps.map((_, index) => (
                <Step key={index} index={index} steps={steps} />
            ))}
        </Stack>
    );
});

const GreyLine = styled(Box)(({ theme, completed, disabled }) => {
    return {
        flexGrow: 1,
        width: '2px',
        background: completed ? theme.palette.ensightful.success[700] : theme.palette.ensightful.neutral[700],
        ...(!completed &&
            !disabled && {
                opacity: 0.4,
            }),
    };
});

export default Steps;
